"use client";

import { useState } from "react";
import base from "lib/base";
import AuthorModal from "./AuthorModal";
import CompanyModal from "./CompanyModal";
import { BookCard } from "./BooksSection";
import styles from "styles/components/books-grouped.module.css";

const resolveImage = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${base.cdnUrl}/${path}`;
};

const normalizeId = (val) =>
  val && typeof val === "object" ? val._id || val.id : val;

const BooksGroupedList = ({ groups = [] }) => {
  const groupedList = Array.isArray(groups) ? groups : [];
  const [activeAuthor, setActiveAuthor] = useState(null);
  const [activeCompany, setActiveCompany] = useState(null);

  if (!groupedList.length) {
    return <div className={styles.emptyState}>Одоогоор ном олдсонгүй.</div>;
  }

  return (
    <section className={styles.section}>
      <div className="container">
        {groupedList.map((group, idx) => {
          const author = group.author || {};
          const company = group.company || {};
          const authorAvatar = resolveImage(author?.avatar);
          const companyLogo = resolveImage(company?.logo);
          return (
            <div className={styles.group} key={`${author?._id || "na"}-${idx}`}>
              <div className={styles.groupHeader}>
                <button
                  type="button"
                  className={styles.authorButton}
                  onClick={() => setActiveAuthor(author)}
                >
                  <div className={styles.authorBlock}>
                    <div className={styles.avatarWrap}>
                      {authorAvatar ? (
                        <img
                          src={authorAvatar}
                          alt={author?.name || "Author"}
                        />
                      ) : (
                        <div className={styles.avatarFallback} />
                      )}
                    </div>
                    <div className={styles.authorInfo}>
                      <div className={styles.nameStack}>
                        <div className={styles.authorName}>
                          {author?.name || "Зохиолч"}
                        </div>
                        {author?.title ? (
                          <div className={styles.authorTitle}>
                            {author.title}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </button>
                <div className={styles.companyBlock}>
                  {company?.shortAbout ? (
                    <p className={styles.companyAbout}>{company.shortAbout}</p>
                  ) : (
                    <p className={styles.companyAbout}>
                      {company?.name || "Байгууллага"}
                    </p>
                  )}
                  {companyLogo ? (
                    <button
                      type="button"
                      className={styles.companyButton}
                      onClick={() => setActiveCompany(company)}
                    >
                      <img
                        src={companyLogo}
                        alt={company?.name || "Company"}
                        className={styles.companyLogo}
                      />
                    </button>
                  ) : null}
                </div>
              </div>

              <div className="row gy-4">
                {(group.books || []).map((book) => (
                  <div className="col-12 col-md-6 col-lg-4" key={book._id}>
                    <BookCard book={book} />
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>

      <AuthorModal
        author={activeAuthor}
        open={!!activeAuthor}
        onClose={() => setActiveAuthor(null)}
      />

      <CompanyModal
        company={activeCompany}
        open={!!activeCompany}
        onClose={() => setActiveCompany(null)}
      />
    </section>
  );
};

export default BooksGroupedList;
